<template>
  <v-card class="rounded-card card-shadow">
    <v-card-text class="text--primary--color">
      <v-row dense class="mt-5">
        <v-col cols="12">
          Selecione abaixo os aprovadores para esta regra.
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <px-autocomplete-user-comprador-multiple
            dense
            outlined
            autocomplete="off"
            class="required rounded-tag-small"
            label="Usuários"
            :roles="rolesAprovador"
            :error="$v.regra.aprovadores.$error"
            @blur="$v.regra.aprovadores.$touch()"
            v-model="regra.aprovadores"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-switch dense
                    class="pa-0 mt-2 mr-2"
                    label="Requer aprovação de todos os responsáveis"
                    color="primary"
                    v-model="regra.requerAprovacaoTotal"/>
        </v-col>
      </v-row>
      <v-row dense v-if="edicaoSemAprovacao">
        <v-col cols="12">
          <v-switch dense
                    class="pa-0 mt-2 mr-2"
                    label="Permitir edição sem necessidade de nova aprovação"
                    color="primary"
                    @change="onChangeEditarSemAprovacao"
                    v-model="regra.permiteEditarSemAprovacao"/>
        </v-col>
      </v-row>
      <v-row dense v-if="edicaoSemAprovacao && regra.permiteEditarSemAprovacao">
        <v-col cols="12">
          Selecione os campos que, ao serem alterados, exigirão nova aprovação.
        </v-col>
      </v-row>
      <v-row dense v-if="edicaoSemAprovacao && regra.permiteEditarSemAprovacao">
        <v-col cols="12">
          <px-select-enum
            dense
            multiple
            small-chips
            clearable
            chips
            deletable-chips
            outlined
            hide-details
            label="Critério de Edição"
            class="rounded-tag-small"
            v-model="regra.criteriosEdicoes"
            :items="criteriosEdicao"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import CampoCriterioEdicao from '@/enums/campo-criterio-edicao';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  computed: {
    criteriosEdicao() {
      return CampoCriterioEdicao.values;
    },
  },
  props: {
    regra: {
      type: Object,
      required: true,
    },
    rolesAprovador: {
      type: Array,
      required: true,
    },
    edicaoSemAprovacao: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isValid() {
      return !this.validateForm();
    },
    onChangeEditarSemAprovacao(newValue) {
      if (!newValue) {
        this.regra.criteriosEdicoes = [];
      }
    },
  },
  validations: {
    regra: {
      aprovadores: {
        required,
      },
    },
  },
};
</script>
